export default __webpack_public_path__ + "static/media/carousel1.d899f1b9.jpg";